export default {
  'cash-registers': {
    'register': {
      'transactions': 'Transactions',
      'summary': 'Summary',
      'closed': 'Closed',
      'opened': 'Opened',
      'opening-float': 'Opening float',
      'total': 'Total',
      'open': 'Open',
      'report': 'Report',
      'close': 'Close',
      'reopen': 'Reopen',
      'new-sale': 'New Sale',
      'cash-in-out': 'Cash In / Out',
      'empty-title': 'To make a sale, please select register from the list or open a new one',
    },
    'register-summary': {
      'expected': 'Expected',
      'counted': 'Counted',
      'diff': 'Diff',
      'cash-closing-float': 'Register Closing Float',
      'total': 'Total',
      'cash-opening-float': 'Cash Opening Float',
      'cash-payments': 'Cash Payments',
      'cash-in': 'Cash In',
      'cash-out': 'Cash Out',
    },
    'register-operations': {
      'appointment': 'Appointment',
      'cancellation-fee': 'Cancellation Fee',
      'paid': 'Paid',
      'cash-closing-float': 'Cash closing float',
      'cash-opening-float': 'Cash opening float',
    },
    'registers-list': {
      'open': 'Open',
      'closed': 'Closed',
      'total': 'Total',
      'opening': 'Opening',
      'empty-title': 'No Registers opened yet...',
      'empty-description': 'To make a sale, please open the new register by clicking “+” button',
      'register-is-open': 'Register is open',
      'register-is-open-description': 'To open a new register, you must close the current one first.',
      'close-current-register': 'Close current register',
    },
    'open-register-modal': {
      'title': 'Open Register',
      'cash-opening-float': 'Cash Opening Float',
      'optional-note': 'Optional Note',
      'opening-cash-min-value': 'Opening cash should be greater or equal 0',
      'opening-note-max-value': 'Ensure this field has no more than 500 characters.',
    },
    'cash-closing-float-modal': {
      'title': 'Cash Closing Float',
      'counted-amount': 'Counted Amount',
    },
    'closing-register': {
      'title': 'Close Register',
      'confirm-and-close-register': 'Confirm & Close Register',
    },
    'counted-modal': {
      'amount': 'Counted Amount',
      'amount-min-value': 'Counted amount should be greater or equal 0',
    },
    'cash-in-out-modal': {
      'title': 'Cash In / Cash Out',
      'cash-in': 'Cash In',
      'cash-out': 'Cash Out',
      'date': 'Date',
      'issued-by': 'Issued by',
      'document-number': 'Document Number (optional)',
      'items': 'Items',
      'item-name': 'Person / item / note',
      'item-account': 'Account (optional)',
      'item-amount': 'Cash Amount',
      'add-item': 'Add Item',
      'items-required-message': 'There should be at least one item',
      'amount-item-min-value': 'Amount must be greater than zero',
      'name-item-min-length': 'This field may not be blank',
      'comment': 'Comment (optional)',
    },
    'buyer-input-search': {
      'placeholder': 'Bill to (optional)',
      'tax-id': 'Tax ID',
    },
  },
  'transactions': {
    'search': {
      'placeholder': 'Search by client or transaction id',
      'appointment': 'Appointment',
      'paid': 'Paid',
      'title': 'Transactions',
    },
    'empty-history': {
      title: 'No Transaction History',
      description: 'A full list of your transactions will appear here.',
    },
    'scope': {
      'days': 'Days',
      'months': 'Months',
      'custom': 'Custom',
    },
    'summary': {
      'show-list': 'Show list',
      'total': 'Total',
    },
    'no-results': 'You don\'t have any transactions in this period',
  },
  'invoices': {
    'form': {
      'edit-correct-invoice': 'Edit a correcting Invoice',
      'add-correct-invoice': 'Issue a correcting Invoice',
      'edit-invoice': 'Edit an Invoice',
      'add-invoice': 'Issue an Invoice',
      'to-invoice-no': 'to invoice No.',
      'issue-date': 'Issue Date',
      'sales-date': 'Sales Date',
      'due-date': 'Due Date',
      'company': 'Company',
      'company-details': 'Company details',
      'items': 'Items',
      'add-item': 'Add item',
      'description': 'Description (optional)',
      'correction-reason': 'Correction reason',
      'payment-method': 'Payment method',
      'subtotal': 'Subtotal',
      'discount': 'Discount',
      'invoice-number': 'Invoice number (optional)',
      'issued-by': 'Issued by',
      'total': 'Total',
      'invoice-paid': 'Invoice Paid',
      'tax-id': 'Tax ID',
      'item-quantity-min-value': 'Ensure this value is greater than or equal to 1',
      'void': 'Void',
      'refund-title': 'Update invoice and process refund?',
      'refund-subtitle': 'In addition to modifying the invoice let us know if you would like to offer a full refund to the customer. If not we’ll update the invoice, but no refund will be processed.',
      'process-refund': 'Process Refund',
      'update-without-refund': 'Update Without Refund',
      'not-refund-title': 'Invoice updated',
      'not-refund-subtitle': 'We’ve updated your invoice to reflect the changes you made. If a refund is also required please remember to process that offline.',
      'got-it': 'Got it',
    },
    'invoice-row': {
      'item': 'Item',
      'quantity': 'qty',
      'unit': 'Unit',
      'unit-net-price': 'Net unit price',
      'unit-gross-price': 'Gross unit price',
      'tax': 'Tax',
      'tax-rate': 'Tax rate',
      'tax-amount': 'Tax amount',
      'value-net': 'Value net',
      'value-gross': 'Value gross',
    },
    'list': {
      'title': 'Invoices',
      'search': 'Search by client or invoice number',
      'empty': 'No invoices yet...',
    },
    'invoice': {
      'title': 'Invoice No.',
      'subtitle': 'To receipt No. {number}',
      'issue-date': 'Date of issue',
      'sale-date': 'Date of sale',
      'due-date': 'Due Date',
      'seller': 'Seller',
      'buyer': 'Buyer',
      'payment-method': 'Payment method',
      'total-net': 'Total Net',
      'total-gross': 'Total Gross',
      'net-value': 'Net value',
      'gross-value': 'Gross Value',
      'total': 'Total',
      'subtotal': 'Subtotal',
      'discount': 'Discount',
      'tax-id': 'Tax ID',
      'send': 'Send',
      'send-success': 'Invoice has been sent successfully',
      'receipt-id': 'Receipt ID',
      'correcting': 'Correcting Invoice',
      'void': 'Void',
      'value-net': 'Value net',
      'value-gross': 'Value gross',
      'tax-free': 'free',
    },
    'search': {
      'label': 'Search on client file',
      'no-company-details': '(no company details)',
    },
    'buyer-form': {
      'title': 'Company Details',
      'save-company-details': 'Save company details on client card',
      'choose-company': 'Select a company first',
      'delete-company': {
        'title': 'Delete Company Details?',
        'text': 'Action cannot be undone.',
      },
    },
    'filters': {
      'all': 'All',
      'unpaid': 'Unpaid',
      'overdue': 'Overdue',
      'paid': 'Paid',
    },
    'create': {
      'success': 'Invoice was created successfully',
      'error': 'Could not create invoice',
      'company-selector': 'Select Company',
      'create-an-invoice': 'Create an invoice',
      'add-company-details': 'Add Company Details',
    },
  },
  'payment-method': {
    'transfer': 'Bank transfer',
    'cash': 'Cash',
    'credit-card': 'Credit card',
    'mobile-payment': 'Mobile Payment',
  },
  'fiscal-receipts': {
    'fiscal-receipt-item': {
      'sale': 'Sale',
      'cancellation': 'Cancellation',
    },
    'list': {
      'title': 'Transactions',
      'select-date': 'Select a date or date range',
      'no-results': 'You don\'t have any transactions in this period',
    },
    'tabs': {
      'days': 'Days',
      'custom': 'Custom',
    },
    'fiscal-receipt': {
      'date-of-creation': 'Date of creation',
      'title': 'Receipt No.',
      'created-by': 'Created by',
      'id': 'ID',
      'type-of-operation': 'Type of operation',
      'document-type': 'Operation type',
      'customer-id': 'Customer ID',
      'signature': 'Signature extract',
      'cancelled-receipt': 'Cancelled receipt',
      'final-receipt': 'Final Receipt',
      'prepayment-receipt': 'Deposit Receipt',
      'cancellation': 'Cancellation',
      'cancellation-reason': 'Cancellation reason',
      'software': 'Software',
      'siret': 'No. SIRET',
      'tax-id': 'Tax ID',
      'naf-code': 'NAF Code',
      'tax-code': 'Tax Code',
      'tax-rate': 'Tax Rate',
      'quantity': 'Quantity',
      'service-or-product-name': 'Service or Product Name',
      'unit-gross': 'Gross Unit Price',
      'total-gross-price': 'Gross Total Price',
      'discount': 'Discount',
      'global-discount': 'Global Discount',
      'total-tax': 'Total VAT',
      'total-net': 'Total net',
      'total': 'Total gross',
      'total-paid': 'Total Paid',
      'total-discount': 'Total discounts including tax',
      'cancel-receipt': 'Cancel receipt',
      'print-receipt': 'Print',
      'summary': 'Summary',
      'loyality-program': {
        'title': 'Loyalty Program',
        'balance-before': 'Balance before the visit',
        'balance-after': 'Balance after the visit',
        'collected': 'Collected during the visit',
      },
      'refund': 'Refund',
      'prepayment': 'Deposit',
      'total-remaining': 'Total Remaining Gross',
    },
    'print-original-modal': {
      'title': 'Print Receipt no. {number}',
      'description': '<strong>Original receipt</strong><br><br>The receipt you want to print is the original. Any subsequent receipt will be a duplicate. Are you sure you want to print it?',
      'confirm-button': 'Print the original receipt',
    },
    'print-duplicate-modal': {
      'title': 'Print Receipt no. {number}',
      'description': '<strong>Duplicate receipt</strong><br><br>The receipt you want to print is a duplicate. To print it, you need to fill out the reason form. Are you sure you want to print it?',
    },
    'send-modal': {
      'title': 'Send Receipt no. {number}',
      'description-original': '<strong>Original receipt</strong><br><br>The receipt you want to send is the original, any subsequent receipt will be a duplicate. Are you sure you want to send it?',
      'description-duplicate': '<strong>Duplicate receipt</strong><br><br>The receipt you want to send is a duplicate. To send it, you need to fill out the reason form. Are you sure you want to send it?',
    },
    'send-form': {
      'email': 'Send receipt to client via e-mail',
      'reason': 'Reason for sending',
      'send-original': 'Send original receipt',
      'send-duplicate': 'Send duplicate receipt',
      'success': 'Receipt No. {number} was sent',
    },
    'print-duplicate-reason': {
      'reason': 'Print reason',
      'btn-1-text': 'Print a duplicate receipt',
    },
    'cancel-receipt-modal': {
      'title': 'Do you want to cancel Receipt {number}?',
      'description': 'In the list of transactions you will see a new receipt with the cancelled status.',
    },
    'cancellation-reason': {
      'btn-1-text': 'Yes, cancel receipt',
      'reason': 'Reason for cancellation',
      'success': 'Receipt has been cancelled',
      'banner-text': 'Mobile Payments and Deposits will not be returned automatically. You can return them using the REFUND button in the receipt details.',
    },
  },
  'fiscal-receipts-label': {
    'sale': 'Sale',
    'cancellation': 'Cancellation',
    'cancelled': 'Cancelled',
  },
  'no-staff-assigment': 'No staff assignment',
  'dont-ask-again': 'Don\'t show this window again (you can edit sale assignment by clicking on individual cart items)',
  'fiscal-archives': {
    'gross-total': 'Total gross',
    'net-total': 'Total net',
    'list': {
      'title': 'Archives',
      'no-results': 'You don\'t have any archives in this period',
    },
    'tabs': {
      'days': 'Days',
      'months': 'Months',
      'years': 'Years',
    },
  },
}
